import { render, staticRenderFns } from "./npm_installation.vue.js?vue&type=template&id=5d151d91!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./npm_installation.vue?vue&type=template&id=5d151d91"
import script from "./npm_installation.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./npm_installation.vue?vue&type=script&lang=js"
export * from "./npm_installation.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./npm_installation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports